import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';

import { LocalDevSignin } from './pages/LocalDev/Signin';
import Team from './routes/Team';

export function Routes() {
  return (
    <RouterRoutes>
      <Route path="/local-dev/signin" element={<LocalDevSignin />} />
      <Route path="/" element={<Navigate to="/team" replace />} />
      <Route path="/team/*" element={<Team />} />
      <Route path="*" element={<Navigate to="/team" replace />} />
    </RouterRoutes>
  );
}
